import 'leaflet-draw';
import equal from 'fast-deep-equal/es6';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, ReactNode, useEffect, useRef } from 'react';
import { usePrevious } from '../../../../design/hooks/usePrevious';
import { useMap } from '../../../../useMap';
import { ISegmentation } from '../annotations.interface';
import { AttributesPopupDrawer } from './DrawControl.models/AttributesPopupDrawer';

interface IProps extends PropsWithChildren {
  selectedAttributes: string[];
  showAttributesHeaders: boolean;
  selectedSegmentation?: ISegmentation;
  hoveredSegmentation?: string;
  segmentations: ISegmentation[];
  children: ReactNode;
  imageId: string;
}

export const AttributePopupControl = observer((props: IProps): ReactElement => {
  const attributesPopupDrawer = useRef<AttributesPopupDrawer>(null);
  const previousProps = usePrevious(props);
  const map = useMap();
  const { selectedSegmentation, selectedAttributes, segmentations, showAttributesHeaders, hoveredSegmentation, children } = props;

  useEffect(() => {
    attributesPopupDrawer.current = new AttributesPopupDrawer(map);
    attributesPopupDrawer.current.refresh(selectedSegmentation, selectedAttributes, segmentations, showAttributesHeaders);
    return (): void => {
      attributesPopupDrawer.current?.clear();
    };
  }, [props.imageId]);

  useEffect(() => {
    if (previousProps?.hoveredSegmentation !== hoveredSegmentation) {
      if (hoveredSegmentation === undefined && previousProps?.hoveredSegmentation !== undefined) {
        attributesPopupDrawer.current?.hout(previousProps.hoveredSegmentation);
      } else if (hoveredSegmentation) {
        attributesPopupDrawer.current?.hover(hoveredSegmentation);
      }
    } else if (
      selectedSegmentation !== previousProps?.selectedSegmentation ||
      !equal(selectedAttributes, previousProps?.selectedAttributes) ||
      !equal(segmentations, previousProps?.segmentations) ||
      showAttributesHeaders !== previousProps?.showAttributesHeaders
    ) {
      attributesPopupDrawer.current?.refresh(selectedSegmentation, selectedAttributes, segmentations, showAttributesHeaders);
    }
  }, [selectedSegmentation, selectedAttributes, segmentations, hoveredSegmentation, showAttributesHeaders]);

  return <>{children}</>;
});
